import { MarketingDataKeys, MarketingStore } from 'store/marketing/types'
import { readCookie } from 'utils/cookies'
import { CookieKeys } from 'types/cookies'
import { IDENTIFICATION_METHODS, OPT_IN_CTAS, SIGN_CHANNELS, SIMULATION_TYPES, SOURCE_TYPES } from '@boltenergy-be/shared'

export const initialMarketingState: MarketingStore = {
  [MarketingDataKeys.IDENTIFICATION_METHOD]: IDENTIFICATION_METHODS.default,
  [MarketingDataKeys.ADJUSTABLE_PRODUCT]: false,
  [MarketingDataKeys.CREDIT_CHECK_CONFIRMATION_FLOW]: false,
  [MarketingDataKeys.CONFIRMATION_FROM_PORTAL_REGISTRATION]: false,
  [MarketingDataKeys.EAN_CODE_MANDATORY]: false,
  [MarketingDataKeys.EMAIL_CONFIRMATION_FLOW]: false,
  [MarketingDataKeys.EXECUTE_CREDIT_CHECK]: true,
  [MarketingDataKeys.FETCH_SIMULATION_FLOW]: false,
  [MarketingDataKeys.GCLID]: readCookie(CookieKeys.GCLID),
  [MarketingDataKeys.NO_EAN_FLOW]: false,
  [MarketingDataKeys.NO_OPTIN_ONE]: false,
  [MarketingDataKeys.OPTIN_CTA]: OPT_IN_CTAS.switchNow,
  [MarketingDataKeys.PREVIOUS_SUPPLIER]: false,
  [MarketingDataKeys.RESET_BUTTON]: false,
  [MarketingDataKeys.SIGN_CHANNEL]: [SIGN_CHANNELS.none],
  [MarketingDataKeys.SIMULATION_TYPE]: [SIMULATION_TYPES.pricingSimulation],
  [MarketingDataKeys.SKIP_ITSME]: false,
  [MarketingDataKeys.SOURCE_TYPE]: SOURCE_TYPES.pull,
  [MarketingDataKeys.TRIGGER_EVENTS]: ''
}
